let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7B6SQ")).then(() => parcelRequire('1LLLM'));